<div class="w-full mb-4 bg-white rounded-md">
  <div class="p-4 bg-white rounded-md shadow border border-gray-200">
    <h3 class="text-base md:text-lg font-medium text-center text-[#c19725] mb-4">
      Add New Category
    </h3>

    <form [formGroup]="addCategoryForm" (ngSubmit)="addCategory()">
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-2.5 md:gap-3 items-start">

        <!--category type-->
        <div class="flex flex-col">
          <select formControlName="newType"
            [ngClass]="{ 'border-red-500': addCategoryForm.get('newType')?.invalid && addCategoryForm.get('newType')?.touched }"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm">
            <option selected hidden disabled value="">Select Type</option>
            <option value="Assembly">Assembly</option>
            <option value="Master">Ready Product</option>
            <option value="Product">Product</option>
            <option value="Stone">Stone</option>
            <option value="Metal">Metal</option>
          </select>
          <span *ngIf="addCategoryForm.get('newType')?.invalid && addCategoryForm.get('newType')?.touched" class="text-red-500 text-xs mt-1">
            Please select type
          </span>
        </div>

        <!--category sub type for ready product only-->
        <div *ngIf="addCategoryForm.value.newType === 'Master'" class="flex flex-col">
          <select formControlName="newSubType"
            [ngClass]="{ 'border-red-500': addCategoryForm.get('newSubType')?.invalid && addCategoryForm.get('newSubType')?.touched }"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm">
            <option selected hidden disabled value="">Lot / Piece</option>
            <option value="lot">Lot</option>
            <option value="piece">Piece</option>
          </select>
          <span *ngIf="addCategoryForm.get('newSubType')?.invalid && addCategoryForm.get('newSubType')?.touched" class="text-red-500 text-xs mt-1">
            Please select Lot / Piece
          </span>
        </div>

        <!-- Category Name -->
        <div class="flex flex-col">
          <input type="text" formControlName="newCategoryName" autocomplete="off" placeholder="Enter new category name"
            [ngClass]="{ 'border-red-500': addCategoryForm.get('newCategoryName')?.invalid && addCategoryForm.get('newCategoryName')?.touched }"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm" />
          <span *ngIf="addCategoryForm.get('newCategoryName')?.invalid && addCategoryForm.get('newCategoryName')?.touched" class="text-red-500 text-xs mt-1">
            Please enter category name
          </span>
        </div>

        <!-- Category Code -->
        <div class="flex flex-col">
          <input type="text" formControlName="newCode" autocomplete="off" placeholder="Enter category code"
            [ngClass]="{ 'border-red-500': addCategoryForm.get('newCode')?.invalid && addCategoryForm.get('newCode')?.touched }"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm" />
          <span *ngIf="addCategoryForm.get('newCode')?.invalid && addCategoryForm.get('newCode')?.touched" class="text-red-500 text-xs mt-1">
            Please enter category code
          </span>
        </div>

        <!-- Unit -->
        <div *ngIf="addCategoryForm.value.newType != 'Stone' && addCategoryForm.value.newType != 'Metal'" class="flex flex-col">
          <select formControlName="newUnit"
            [ngClass]="{ 'border-red-500': addCategoryForm.get('newUnit')?.invalid && addCategoryForm.get('newUnit')?.touched }"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm">
            <option selected hidden disabled value="">Select Unit</option>
            <option value="By Gram">By Gram</option>
            <option value="By Silver Rate">By Silver Rate</option>
            <option value="By MRP">By MRP</option>
          </select>
          <span *ngIf="addCategoryForm.get('newUnit')?.invalid && addCategoryForm.get('newUnit')?.touched" class="text-red-500 text-xs mt-1">
            Please select unit
          </span>
        </div>

        <!-- MRP -->
        <div *ngIf="addCategoryForm.value.newType != 'Stone' && addCategoryForm.value.newType != 'Metal'" class="flex flex-col">
          <input type="text" formControlName="MRP" autocomplete="off" placeholder="Enter Per Gm Rate" (keydown)="allowOnlyNumbers($event)"
            class="w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm" />
        </div>

        <div class="flex flex-col sm:flex-row gap-3">
          <!-- Submit -->
          <button type="submit" *ngIf="!isEditMode" class="block cursor-pointer capitalize w-full sm:w-[110px] lg:w-[200px]
           p-1 md:p-1.5 text-base xl:text-lg font-bold
           text-white bg-c19725 border border-c19725
           hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
           focus:ring-0 focus:outline-none rounded-md text-center">
            Add
          </button>

          <!-- Update -->
          <button type="submit" *ngIf="isEditMode" class="block cursor-pointer capitalize w-full sm:w-[110px] lg:w-[200px]
           p-1 md:p-1.5 text-base xl:text-lg font-bold
           text-white bg-c19725 border border-c19725
           hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
           focus:ring-0 focus:outline-none rounded-md text-center">
            Update
          </button>

          <!-- Clear -->
          <button type="button" (click)="resetForm()" class="block cursor-pointer capitalize w-full sm:w-[110px] lg:w-[200px]
           p-1 md:p-1.5 text-base xl:text-lg font-bold
           text-white bg-c19725 border border-c19725
           hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
           focus:ring-0 focus:outline-none rounded-md text-center">
            Clear
          </button>
        </div>

      </div>
    </form>
  </div>
  <div class="w-full py-3 px-2 lg:px-4">
    <div class="flex items-center justify-between mb-4">

      <!-- Title -->
      <p class="font-semibold text-sm sm:text-base lg:text-xl text-[#444]">
        Category List
      </p>

      <!-- Dropdown -->
      <select class="px-6 py-2 text-sm sm:text-base
               border border-gray-300 rounded-md text-c19725
               focus:outline-none focus:ring-2 focus:ring-[#c19725]" [value]="selectedCategoryFilter"
        (change)="onCategoryFilterChange($event)">
        <option value="">All Categories</option>
        <option value="Assembly">Assembly</option>
        <option value="Master">Ready Product</option>
        <option value="Stone">Stone</option>
        <option value="Metal">Metal</option>
      </select>

    </div>

    <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
      <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
        <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
          <tr>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Name</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Code</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Type</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Lot/Piece</th>
            <!-- <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Group</th> -->
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Unit</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">MRP</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action
          </tr>
        </thead>
        <tbody class="text-xs sm:text-xs">
          <tr *ngFor="let category of pagedCategories; let i = index"
            class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]">
            <td class="p-3 text-center">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td class="p-3 text-center">{{ category.name || '-' }}</td>
            <td class="p-3 text-center">{{ category.code || '-' }}</td>
            <td class="p-3 text-center">{{ category.Type === 'Master' ? 'Ready Product' : (category.Type || '-') }}</td>
            <td class="p-3 text-center">{{ category.SubType || '-' }}</td>
            <!-- <td class="p-3 text-center">{{ category.group || '-' }}</td> -->
            <td class="p-3 text-center">{{ category.unit || '-' }}</td>
            <td class="p-3 text-center">{{ category.mrp || '-' }}</td>
            <td class="p-3 text-center">
              <div class="flex items-center justify-center gap-3">

                <!-- View/Edit Button -->
                <button class="cursor-pointer" (click)="editCategory(category)">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                      stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>

                <button aria-label="Delete Category"
                  class="icon-btn text-[#BB0000] hover:scale-110 hover:text-[#990000]" title="Delete Category"
                  (click)="deleteCategory(category.id)">
                  <svg class="w-5 h- md:w-6 md:h-6" fill="none" viewBox="0 0 24 25">
                    <path d="M10 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M14 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M4 7.5H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex items-center justify-end gap-2 mt-4">

        <button class="px-3 py-1 border rounded-md text-sm
                 disabled:opacity-50" (click)="prevPage()" [disabled]="currentPage === 1">
          Prev
        </button>

        <button *ngFor="let page of [].constructor(totalPages); let i = index"
          class="px-3 py-1 border rounded-md text-sm" [class.bg-c19725]="currentPage === i + 1"
          [class.text-white]="currentPage === i + 1" (click)="goToPage(i + 1)">
          {{ i + 1 }}
        </button>

        <button class="px-3 py-1 border rounded-md text-sm
                 disabled:opacity-50" (click)="nextPage()" [disabled]="currentPage === totalPages">
          Next
        </button>

      </div>
    </div>
  </div>
</div>